import React, { useState, useEffect } from 'react';
import './VideoHero.css';

const VideoHero = ({ videoSrc }) => {
  const [videoError, setVideoError] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    const video = document.querySelector('.video-hero__background');
    if (video) {
      video.onloadeddata = () => {
        console.log('Video loaded successfully');
        setVideoLoaded(true);
        setVideoError(false);
      };
      video.onerror = (e) => {
        console.error('Video error:', e);
        setVideoError(true);
        setVideoLoaded(false);
      };
    }
  }, []);

  return (
    <div className="video-hero">
      {videoError ? (
        <div className="video-hero__error">
          Video could not be loaded. Please try again later.
          <br />
          <small>Source: {videoSrc}</small>
        </div>
      ) : (
        <>
          <video
            autoPlay
            loop
            playsInline
            controls
            controlsList="nodownload nofullscreen"
            className="video-hero__background"
            style={{
              opacity: videoLoaded ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out'
            }}
            onLoadedData={(e) => {
              console.log('Video loaded:', e.target.src);
              e.target.play().catch(err => console.error('Play failed:', err));
              setVideoLoaded(true);
            }}
            onError={(e) => {
              console.error('Video error:', e);
              setVideoError(true);
            }}
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="video-hero__overlay"></div>
        </>
      )}
    </div>
  );
};

export default VideoHero;
